import { AccessPermissions } from '@circlefin/permissions'
import { FeatureSwitch } from '@services/feature-switch'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Travel Rule Secure PII Exchange Section.
 */
export const TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION: PermissionSet = {
  access: FeatureSwitch.isTravelRuleSecurePIIExchangeEnabled()
    ? AccessPermissions.public
    : AccessPermissions.restricted,
  includeAll: [],
}
